import React from 'react'
import { FaLaptopCode, FaRocket, FaTools, FaUsers, FaChartLine, FaCheckCircle } from 'react-icons/fa';
import '../css/Home.css';
import { motion } from 'framer-motion';

function WorkSteps() {
    const roadmapData = [
        {
            id: 1,
            icon: <FaRocket size={45} />,
            title: 'Analysis',
            desc: 'Requirements testing'
        },
        {
            id: 2,
            icon: <FaLaptopCode size={45} />,
            title: 'Design',
            desc: 'UX/UI testing'
        },
        {
            id: 3,
            icon: <FaTools size={45} />,
            title: 'Development',
            desc: ''
        },
        {
            id: 4,
            icon: <FaUsers size={45} />,
            title: 'Quality Assurance',
            desc: 'Stabilization'
        },
        {
            id: 5,
            icon: <FaChartLine size={45} />,
            title: 'Deployment',
            desc: ''
        },
        {
            id: 6,
            icon: <FaCheckCircle size={45} />,
            title: 'Support',
            desc: 'Acceptance testing'
        },
    ];

    return (
        <><motion.section className="container my-5"
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: false, amount: 0.6 }}
            transition={{ duration: 0.8, ease: "easeOut" }}>
            <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                <div
                    className="px-3 fw-bold responsive-heading"
                >
                    Our <span className="highlight-orange">Roadmap to Success  </span>in Software Development
                </div>
            </div>
            {/* <div className="d-flex justify-content-center mt-4">
                <a
                    href="#contact-us"
                    className="btn custom-orange-btn py-3 px-4 fw-bold"
                >
                    Book a Free Consultation
                </a>
            </div> */}
        </motion.section>
            <section className="container my-5">
                <div className="position-relative py-5">
                    {/* Line */}
                    <div
                        className="position-absolute top-50 start-0 end-0 translate-middle-y"
                        style={{ height: '2px', backgroundColor: '#ccc', zIndex: 1 }}
                    ></div>

                    <div className="row row-cols-1 row-cols-md-6 g-4 justify-content-center text-center position-relative" style={{ zIndex: 2 }}>
                        {roadmapData.map((step, idx) => (
                            <motion.div
                                key={idx}
                                className="col d-flex flex-column align-items-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: idx * 0.2 }}
                                viewport={{ once: false, amount: 0.5 }}>
                                {/* Step Marker */}
                                <div
                                    className="rounded-circle shadow d-flex align-items-center justify-content-center mb-3"
                                    style={{
                                        width: '50px',
                                        height: '50px',
                                        background: 'linear-gradient(to right, #ec4899, #ef4444, #8b5cf6)',
                                        color: '#fff',
                                        fontWeight: 'bold',
                                        zIndex: 2,
                                    }}

                                >
                                    {step.id}
                                </div>
                                {/* Icon */}
                                <div className="text-orange mb-2" style={{ color: '#8b5cf6' }}>
                                    {step.icon}
                                </div>
                                {/* Title */}
                                <h6 className="fw-bold mb-1">{step.title}</h6>
                                {/* Description */}
                                <p className="small text-muted mb-0">{step.desc}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section></>
    )
}

export default WorkSteps